import React from 'react';
import { Field, ErrorMessage } from 'formik';

export const StepEight = () => (
  <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step9">
    <div className="mb-6 form-text2-main">
      <div className="cdf__field__wrapper  form-control2">
        <p>
          <strong>Detailed case description </strong>
          <span>*</span>
        </p>
        <p>
          Describe your case in detail. The more you
          provide, the better the advice will be.
        </p>
        <Field rows={8} name="case_summary" component="textarea" maxLength="10000" />
        <ErrorMessage name="case_summary" component="div" className="required-text" />
      </div>
    </div>
  </div>
);
